import { apiRequest } from '../api';

// Package "jobrestore": Admin → Jobs → Removed jobs (server/src/routes/jobs.ts, GET /jobs/removed +
// POST /jobs/:id/restore). Jobs are only ever soft-deleted, so a removed one can be put back whole.
export interface RemovedJob {
  id: string;
  job_no: number;
  first_name: string;
  last_name: string;
  specific_job: string;
  process_level: string;
  sales_order_no: string;
  line_net: number;
  amount_paid: number;
  balance_due: number;
  source_type: string;
  company_id: string;
  /** When it was removed (unix seconds; 0 when the removal was never stamped). */
  deleted_at: number;
  /** Who removed it — a person's name, or 'System (line removed)' / 'System (source removed)'. */
  deleted_by_name: string;
  /** The reason the person gave when deleting it by hand; '' for a system removal (its reason is in deleted_by_name). */
  delete_reason: string;
  /** The live job that holds this one's document line now, if another has taken its place. */
  stand_in: number | null;
}
export interface RemovedPage { rows: RemovedJob[]; total: number; page: number; limit: number }
export interface RestoredJob {
  ok: true; job_no: number; specific_job: string; process_level: string;
  was_deleted_at: number; was_deleted_by_name: string;
}

export const jobRestoreApi = {
  list: (q: string, page: number, limit: number): Promise<RemovedPage> =>
    apiRequest('GET', `/jobs/removed?q=${encodeURIComponent(q)}&page=${page}&limit=${limit}`),
  restore: (id: string): Promise<RestoredJob> =>
    apiRequest('POST', `/jobs/${encodeURIComponent(id)}/restore`),
};
